import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Ban, FileQuestion, Home, SearchX } from "lucide-react";

const iconMap = {
  notFound: FileQuestion,
  accessDenied: Ban,
  noData: SearchX,
};

const CommonStatePage = ({
  type = "notFound",
  code,
  title,
  description,
  primaryButtonText = "Go to Home",
  primaryButtonPath = "/",
  showBackButton = true,
  fullScreen = true,
}) => {
  const navigate = useNavigate();

  const Icon = iconMap[type] || FileQuestion;

  return (
    <div
      className={`flex w-full items-center justify-center bg-gradient-to-br from-[#f8faff] via-white to-[#eef3ff] px-5 py-10 ${
        fullScreen ? "min-h-screen" : "min-h-[450px]"
      }`}
    >
      <div className="w-full max-w-[580px] text-center">
        {/* Icon */}
        <div className="relative mx-auto mb-7 flex h-[120px] w-[120px] items-center justify-center">
          <div className="absolute inset-0 rounded-full bg-[#3357a4]/10" />

          <div className="absolute inset-[12px] rounded-full bg-[#3357a4]/10" />

          <div className="relative flex h-[76px] w-[76px] items-center justify-center rounded-full bg-gradient-to-br from-[#1A1349] to-[#334F90] shadow-[0_15px_40px_rgba(51,79,144,0.3)]">
            <Icon size={36} className="text-white" strokeWidth={1.8} />
          </div>
        </div>

        {code && (
          <h1 className="mb-2 bg-gradient-to-r from-[#1A1349] to-[#334F90] bg-clip-text text-[72px] font-extrabold leading-none text-transparent sm:text-[90px]">
            {code}
          </h1>
        )}

        <h2 className="mb-3 text-[26px] font-bold text-[#171b2c] sm:text-[32px]">
          {title}
        </h2>

        <p className="mx-auto mb-8 max-w-[470px] text-[15px] leading-7 text-[#697086] sm:text-[16px]">
          {description}
        </p>

        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          {showBackButton && (
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="inline-flex h-[48px] w-full items-center justify-center gap-2 rounded-xl border border-[#d8deea] bg-white px-6 text-[14px] font-semibold text-[#273044] transition-all duration-200 hover:border-[#334F90] hover:text-[#334F90] sm:w-auto"
            >
              <ArrowLeft size={18} />
              Go Back
            </button>
          )}

          <button
            type="button"
            onClick={() => navigate(primaryButtonPath, { replace: true })}
            className="inline-flex h-[48px] w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#1A1349] to-[#334F90] px-7 text-[14px] font-semibold text-white shadow-[0_10px_25px_rgba(51,79,144,0.25)] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_14px_30px_rgba(51,79,144,0.32)] sm:w-auto"
          >
            <Home size={18} />
            {primaryButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommonStatePage;
